import { render, staticRenderFns } from "./projects_by_charge.vue?vue&type=template&id=fe21f100&"
import script from "./projects_by_charge.vue?vue&type=script&lang=js&"
export * from "./projects_by_charge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe21f100')) {
      api.createRecord('fe21f100', component.options)
    } else {
      api.reload('fe21f100', component.options)
    }
    module.hot.accept("./projects_by_charge.vue?vue&type=template&id=fe21f100&", function () {
      api.rerender('fe21f100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/projects_by_charge.vue"
export default component.exports